module.exports = __webpack_public_path__ + "media/paliwa/electricity@3x-effa993c.svg";